import HeroSection from './components/HeroSection';
import StatsBarSection from './components/StatsBarSection';
import SectorsSection from './components/SectorsSection';
import PortfolioPreviewSection from './components/PortfolioPreviewSection';
import WhySwitzerlandSection from './components/WhySwitzerlandSection';
import InvestorCTASection from './components/InvestorCTASection';

export default function HomePage() {
  return (
    <main>
      <HeroSection />
      <StatsBarSection />
      <SectorsSection />
      <PortfolioPreviewSection />
      <WhySwitzerlandSection />
      <InvestorCTASection />
    </main>
  );
}